/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import TableHeader from "../../Components/Common/TableHeader";
import Loader from "../../Components/Common/Loader";
import TransactionsTable from "../Common/Transactions/TransactionsTable";
import Pagination from "../Common/Pagination";
import TransactionsSearchForm from "../Common/Transactions/TransactionsSearchForm";
import ajaxBank from "../../util/remote/ajaxBank";

function CallTransactions() {

  const [callTransactions, setCallTransactions] = useState(false);
  const [callSearchTerm, setCallSearchTerm] = useState("");
  const [callStartDate, setCallStartDate] = useState("");
  const [callEndDate, setCallEndDate] = useState("");
  const [callPage,setCallPage] = useState(1)
  const [callMeta,setCallMeta] = useState([])
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const getCallTransactions = async (currentPage) => {
      setLoading(true);
      const server_response = await ajaxBank.fetchCallTransactions(currentPage);
      setLoading(false);
      if (server_response.status === "OK") {
        setCallMeta(server_response.details.meta.list_of_pages);
        setCallTransactions(server_response.details.list || []);
      } else {
        setCallTransactions([]);
      }
  };

  const searchCallTransactions = async (e) => {
      if (e) {
          e.preventDefault();
      }
      setLoading2(true);
      const server_response = await ajaxBank.searchCallTransactions(callSearchTerm, callStartDate, callEndDate, callPage);
      setLoading2(false);
      if (server_response.status === "OK") {
        setCallMeta(server_response.details.meta.list_of_pages);
        setCallTransactions(server_response.details.list || []);
      } else {
        setCallTransactions([]);
      }
    
    };
  const setCall = (e) => {
    e.preventDefault();
    setCallSearchTerm("");
    setCallStartDate("");
    setCallEndDate("");
    setCallPage(1);
    getCallTransactions(1);
  
  };

  const exportToPDF = () => {
    const pdf = new jsPDF("p", "pt", "a4");
    const columns = ["Transaction Date", "User Details", "Amount"];
    const data = callTransactions.map(item => [
      `${item.created_at?.short_date} ${item.created_at?.time}`,
      `${item.user} (${item.username})`,
      `UGX. ${item.cash_out}`
    ]);

    pdf.autoTable({ head: [columns], body: data });
    pdf.save("call_charges.pdf");
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= callMeta.length) {
      setCallPage(newPage);
    }
  };

  const headers = [
    { label: "Transaction Date", key: "created_at" },
    { label: "User Details", key: "user" },
    { label: "Amount", key: "cash_out" }

  ];

  useEffect(() => {
    if (callSearchTerm || callStartDate || callEndDate) {
      searchCallTransactions();
    } else {
      getCallTransactions(callPage);
    }
  }, [callPage]);

  return (
      <>
      <div class="heading-layout1 mg-b-5">
        <TableHeader subtitle="List of all the call transactions made sorted by the most recent"/>

        <div class="dropdown">
          <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
          <div class="dropdown-menu dropdown-menu-right">
            <Link class="dropdown-item" onClick={exportToPDF} ><i class="fas fa-file-export"></i>Export</Link>
          </div>
        </div>
      </div>

      <TransactionsSearchForm searchTerm={callSearchTerm} setSearchTerm={setCallSearchTerm} startDate={callStartDate}
         setStartDate={setCallStartDate} endDate={callEndDate} setEndDate={setCallEndDate} searchTransactions={searchCallTransactions}
         setTransactions={setCall} setPage={setCallPage} searchTermPlaceholder="Enter first or last name of user..."/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
        {loading || loading2 ? (
          <Loader />
        ) : (
          <TransactionsTable headers={headers} data={callTransactions} isPMTransaction={true}/>
        )}
      </div>
      <Pagination currentPage={callPage} totalPages={callMeta.length} onPageChange={handlePagination}/>
    </>
     
  
  );
}

export default CallTransactions;
